import { SelectColoredOption } from "../../../../common/eff-colored-selector/models/SelectColoredOption";

export class FinalConclusion {
    score?: number;
    conclusion: string;
    availableScores?: SelectColoredOption[] = [];
    author: string;
    /** Transloco key; resolved by the pipe in eff-final-conclusion-box.component.html. */
    authorLabelKey: string;

    scoreName?: string;
    scoreColor?: string;
    message?: string;

    hideScore?: boolean = false;
}
